import React, { Fragment } from "react";
import { renderTextField } from "../../ReduxFormAdapters";
import ValidatedField from "../../Helpers/FieldValidator/ValidatedField";

const AccountFields = ( props ) => {
    return (
        <Fragment>
            <ValidatedField
                name="email"
                component={renderTextField}
                required
                type="email"
                label="Email*"
            />
            <ValidatedField
                name="password"
                component={renderTextField}
                required
                type="password"
                label="Password*"
            />
            <span style={{color: "#0EC362"}}>Password should be least 8 characters long</span>
            <ValidatedField
                name="confirmPassword"
                component={renderTextField}
                required
                type="password"
                label="Confirm Password*"
            />
        </Fragment>
    );
}

export default AccountFields;